<template>
      <div v-if="pgLoading" class="loadingLogo">
    <img src="/assets/img/logo/charity-logo.png" alt="children's heart logo" />
  </div>
    <div v-else class="">

        <Banner
            :background="(item.image) ? item.image.url: ''"
            :title="(!pgLoading) ? ($i18n.locale == 'en') ? item.en.title : item.ar.title : ''">
        </Banner>

         <div class="rules-area ptb-100">
            <div class="container">
                <p v-if="!pgLoading" v-html="($i18n.locale == 'en') ? item.en.body : item.ar.body"></p>
            </div>
        </div>
        
    </div>
</template>

<script>
export default {
    name: 'List',
    components: {
        Banner: () => import('@/components/Banner.vue'),
    },
    data(){
        return {
            //
            item: '',
            refs: 'pages',
            pgLoading: true,
        }
    },
    mounted() {},
    created() {
        //
        //this.fetchData();
    },
    methods: {
        //
        fetchData() {
            window.scrollTo(0,0);
            this.pgLoading = true;
            this.axios.defaults.headers.common = {
                'X-Requested-With': 'XMLHttpRequest', // security to prevent CSRF attacks
            };
            const options = {
                url: window.baseURL+'/pages/'+this.$route.params.slug,
                method: 'GET',
                data: {}
            }
            this.axios(options)
            .then(res => {
                this.pgLoading = false;
                this.item = res.data.data.rows;
            })
            .catch(() => {
                //
                this.$router.push({
                    name: "404",  
                });
            })
            .finally(() => {});
        },
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
